import { useState } from 'react';
import { Container } from '@mui/material';
import '../../css/GlobalStyles.css';

import Page from '../../components/Page';
import DashboardNavbar from '../../layouts/dashboard/DashboardNavbar';
import DashboardSidebar from '../../layouts/dashboard/DashboardSidebar';

import RegionContentCard from '../components/RegionContentCard';

export default function RegionManagement() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Page title="Region Management">
      <DashboardNavbar onOpenSidebar={() => setSidebarOpen(true)} />
      <DashboardSidebar
        isOpenSidebar={sidebarOpen}
        onCloseSidebar={() => setSidebarOpen(false)}
      />

      <Container maxWidth="false">
        <RegionContentCard />
      </Container>
    </Page>
  );
}
